import script from "./PhoneNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneNumber.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneNumber.vue?vue&type=style&index=0&id=4924ae1b&lang=css"

const __exports__ = script;

export default __exports__